/**
 * @surfline/quiver-react v12.14.9 2020-10-22
 */

import React from 'react';
import 'prop-types';
import classNames from 'classnames';
import SurfConditions from '../SurfConditions/SurfConditions.js';
import SpotReportSummary from '../SpotReportSummary/SpotReportSummary.js';
import checkConditionValue from '../utils/checkConditionValue.js';

const getDetailsClassName = showPremiumCamCTA => classNames({
  'quiver-spot-details': true,
  'quiver-spot-details--premium-cta': showPremiumCamCTA
});

const SpotDetails = ({
  spot,
  units,
  showPremiumCamCTA
}) => /*#__PURE__*/React.createElement("div", {
  className: getDetailsClassName(showPremiumCamCTA)
}, /*#__PURE__*/React.createElement("h3", {
  className: "quiver-spot-details__name"
}, spot.name), /*#__PURE__*/React.createElement(SurfConditions, {
  conditions: checkConditionValue(spot.conditions.value),
  expired: spot.conditions.expired && spot.conditions.human
}), /*#__PURE__*/React.createElement(SpotReportSummary, {
  waveHeight: spot.waveHeight,
  tide: spot.tide ? spot.tide : null,
  wind: spot.wind,
  units: units
}));

SpotDetails.defaultProps = {
  showPremiumCamCTA: false
};

export default SpotDetails;
//# sourceMappingURL=SpotDetails.js.map
